import { Feature } from "ol";
import { Geometry } from "ol/geom";
import ReportStrategy from "./report.strategy";

export default class SimpleReportStrategy extends ReportStrategy {
    async getExtraFeatures(): Promise<Feature<Geometry>[]> {
        return []
    }

}